<style scoped>
.btn-evaluacion {
  border: solid 3px #16a275;
}
.btn-evaluacion:hover {
  border-color: #12d1df;
}
.btn-evaluacion.active {
  border-color: #df122e;
}
</style>

<template>
  <b-container fluid>
    <div v-if="OpenClose" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog" style="display: block">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" @click="closeModal()" class="btn-close"></button>
          </div>
          <div class="modal-body" style="height: 500px !important">
            <PDFViewer :source="urlFile" :controls="['zoom']" />
            <!-- <button type="button mt-3" @click="closeModal()">cerrar</button> -->
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
    <b-row>
      <b-col sm="12">
        <card>
          <template v-slot:headerTitle>
            <h4 class="card-title"><b>Sistema de Gestión : PESV</b></h4>
          </template>
          <div class="row text-center pt-4 pb-2">
            <div v-for="itemPesv of items" :key="itemPesv.id" :class="itemPesv.Id == 1 ? 'col-xl-2 col-md-2 col-sm-4  offset-sm-0' : 'col-xl-2 col-md-2 col-sm-4'">
              <button class="btn-evaluacion btn btn-circle btn-secondary" :class="paso == itemPesv.Id ? 'active' : ''" @click="paso = itemPesv.Id">
                <span class="text-white h3">{{ itemPesv.Id }}</span>
              </button>
              <p class="pt-3 h4">{{ itemPesv.DescripcionFase }}</p>
            </div>
            <div class="col-xl-2 col-md-2 col-sm-4">
              <button
                @click="
                  paso = 5;
                  getListaArchivos();
                "
                class="btn-evaluacion btn btn-circle btn-secondary"
                :class="paso == 5 ? 'active' : ''"
              >
                <span class="text-white h3">5</span>
              </button>
              <p class="pt-3 h4">Archivos PESV</p>
            </div>
            <div class="col-xl-2 col-md-2 col-sm-4">
              <button class="btn-evaluacion btn btn-circle btn-secondary" :class="paso == 6 ? 'active' : ''" @click="paso = 6">
                <span class="text-white h3">6</span>
              </button>
              <p class="pt-3 h4">Resultados</p>
            </div>
          </div>
        </card>
        <card class="p-3">
          <div class="row">
            <div class="col-6">
              <label for="sucursal">Sucursal:</label><br />
              <b-form-select
                @change.native="obtenerEvaluacionSucursal()"
                id="sucursal"
                v-model="sucursalSeleccionada"
                value-field="id"
                text-field="descripcion"
                :options="listaSucursales"
              ></b-form-select>
            </div>
            <div class="col-6">
              <div>
                <label for=" " class="form-label">Fecha Evaluación</label>
                <input v-model="item.FechaEvaluacion" placeholder="" type="date" class="form-control text-white" id=" " />
              </div>
            </div>
            <div class="col-6">
              <div>
                <label for=" " class="form-label">Estado de la evaluación:</label>
                <input readonly v-model="item.estado" placeholder="" type="text" class="form-control text-white" id=" " />
              </div>
            </div>

            <div class="col-12">
              <div>
                <vs-button gradient @click.prevent="crearEvaluacion" :disabled="botonNuevaEvaluacion" class="mr-3 mt-3 mb-3" type="submit">Nueva Evaluación</vs-button>
              </div>
            </div>
          </div>
        </card>

        <form @submit.prevent="saveData()">
          <!-- <input type="text" v-model="fecha"> -->
          <card v-if="paso == 1">
            <div class="d-flex flex-reverse" style="width: 100%">
              <vs-button :disabled="camposInactivos" success gradient class="m-3 mb-0" type="submit"> Guardar Evaluación </vs-button>
            </div>
            <div class="text-left p-4">
              <div>
                <span class="text-secondary"
                  ><b> Fases </b><span><b></b></span
                ></span>
              </div>
              <template v-if="items[0].Areas">
                <div class="mt-3 mb-3" v-for="Item in items[0].Areas" :key="Item.Id">
                  <p class="text-light">
                    <b>{{ Item.DescripcionPaso }}</b>
                  </p>
                  <div class="card border border-light p-3">
                    <span class="">{{ Item.ContextoPaso }}</span>
                    <div class="mt-3">
                      <b-form-select
                        class="col-4"
                        :disabled="camposInactivos"
                        v-model="Item.value"
                        value-field="id"
                        text-field="text"
                        :options="options"
                        :key="Item.Id"
                        :id="'select-' + Item.id"
                      >
                        <template #first>
                          <b-form-select-option selected :value="none" disabled>-- selecciona una opción --</b-form-select-option>
                        </template>
                      </b-form-select>
                      <div class="mt-3">
                        <span class="text-light">Cargar plan de mejoramiento (Opcional)</span>
                      </div>
                      <div class="mt-3">
                        <div v-if="!camposInactivos">
                          <DropFile
                            :urlDir="`users/pesv/evaluaciones/${usuario.empresa.id}/${sucursalSeleccionada}/${item.id}/${Item.FaseId}/${Item.Id}`"
                            :pathGet="`PesvPasosEvaluacion/GetPesvListaArchivosId/${item.id}/${Item.Id}/${Item.FaseId}`"
                            pathPost="PesvPasosEvaluacion/CreatePesvPasoEvaluacionArchivo"
                            :injectData="{
                              PesvEvaluacionId: item.id,
                              PasoId: Item.Id,
                              FaseId: Item.FaseId,
                              FechaArchivo: $moment.tz(new Date(), 'America/Costa_Rica').format('YYYY-MM-DDTHH:mm:ssZ'),
                            }"
                            :fileTypes="[
                              'application/pdf',
                              'application/docx',
                              'image/jpeg',
                              'image/png',
                              'image/gif',
                              'application/msword',
                              'application/vnd.ms-excel',
                              'application/vnd.ms-powerpoint',
                              'text/plain',
                              'image/*',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                              'application/vnd.ms-powerpoint',
                              'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
                              'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                              'application/vnd.ms-excel',
                            ]"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </card>

          <card v-if="paso == 2">
            <div class="d-flex flex-reverse" style="width: 100%">
              <button :disabled="camposInactivos" class="btn btn-outline-success m-3 mb-0" type="submit">Guardar Evaluación</button>
            </div>
            <div class="text-left p-4">
              <div>
                <span class="text-secondary"
                  ><b> Fases </b><span><b></b></span
                ></span>
              </div>
              <template v-if="items[1].Areas">
                <div class="mt-3 mb-3" v-for="Item in items[1].Areas" :key="Item.Id">
                  <p class="text-light">
                    <b>{{ Item.DescripcionPaso }}</b>
                  </p>
                  <div class="card border border-light p-3">
                    <span class="">{{ Item.ContextoPaso }}</span>
                    <div class="mt-3">
                      <b-form-select
                        class="col-4"
                        :disabled="camposInactivos"
                        v-model="Item.value"
                        value-field="id"
                        text-field="text"
                        :options="options"
                        :key="Item.Id"
                        :id="'select-' + Item.id"
                      >
                        <template #first>
                          <b-form-select-option selected :value="none" disabled>-- selecciona una opción --</b-form-select-option>
                        </template>
                      </b-form-select>
                      <div class="mt-3">
                        <span class="text-light">Cargar plan de mejoramiento (Opcional)</span>
                      </div>
                      <div class="mt-3">
                        <div v-if="!camposInactivos">
                          <DropFile
                            :urlDir="`users/pesv/evaluaciones/${usuario.empresa.id}/${sucursalSeleccionada}/${item.id}/${Item.FaseId}/${Item.Id}`"
                            :pathGet="`PesvPasosEvaluacion/GetPesvListaArchivosId/${item.id}/${Item.Id}/${Item.FaseId}`"
                            pathPost="PesvPasosEvaluacion/CreatePesvPasoEvaluacionArchivo"
                            :injectData="{
                              PesvEvaluacionId: item.id,
                              PasoId: Item.Id,
                              FaseId: Item.FaseId,
                              FechaArchivo: $moment.tz(new Date(), 'America/Costa_Rica').format('YYYY-MM-DDTHH:mm:ssZ'),
                            }"
                            :fileTypes="[
                              'application/pdf',
                              'application/docx',
                              'image/jpeg',
                              'image/png',
                              'image/gif',
                              'application/msword',
                              'application/vnd.ms-excel',
                              'application/vnd.ms-powerpoint',
                              'text/plain',
                              'image/*',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                              'application/vnd.ms-powerpoint',
                              'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
                              'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                              'application/vnd.ms-excel',
                            ]"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </card>

          <card v-if="paso == 3">
            <div class="d-flex flex-reverse" style="width: 100%">
              <button :disabled="camposInactivos" class="btn btn-outline-success m-3 mb-0" type="submit">Guardar Evaluación</button>
            </div>
            <div class="text-left p-4">
              <div>
                <span class="text-secondary"
                  ><b> Fases </b><span><b></b></span
                ></span>
              </div>
              <template v-if="items[2].Areas">
                <div class="mt-3 mb-3" v-for="Item in items[2].Areas" :key="Item.Id">
                  <p class="text-light">
                    <b>{{ Item.DescripcionPaso }}</b>
                  </p>
                  <div class="card border border-light p-3">
                    <span class="">{{ Item.ContextoPaso }}</span>
                    <div class="mt-3">
                      <b-form-select
                        class="col-4"
                        :disabled="camposInactivos"
                        v-model="Item.value"
                        value-field="id"
                        text-field="text"
                        :options="options"
                        :key="Item.Id"
                        :id="'select-' + Item.id"
                      >
                        <template #first>
                          <b-form-select-option selected :value="none" disabled>-- selecciona una opción --</b-form-select-option>
                        </template>
                      </b-form-select>
                      <div class="mt-3">
                        <span class="text-light">Cargar plan de mejoramiento (Opcional)</span>
                      </div>
                      <div class="mt-3">
                        <div v-if="!camposInactivos">
                          <DropFile
                            :urlDir="`users/pesv/evaluaciones/${usuario.empresa.id}/${sucursalSeleccionada}/${item.id}/${Item.FaseId}/${Item.Id}`"
                            :pathGet="`PesvPasosEvaluacion/GetPesvListaArchivosId/${item.id}/${Item.Id}/${Item.FaseId}`"
                            pathPost="PesvPasosEvaluacion/CreatePesvPasoEvaluacionArchivo"
                            :injectData="{
                              PesvEvaluacionId: item.id,
                              PasoId: Item.Id,
                              FaseId: Item.FaseId,
                              FechaArchivo: $moment.tz(new Date(), 'America/Costa_Rica').format('YYYY-MM-DDTHH:mm:ssZ'),
                            }"
                            :fileTypes="[
                              'application/pdf',
                              'application/docx',
                              'image/jpeg',
                              'image/png',
                              'image/gif',
                              'application/msword',
                              'application/vnd.ms-excel',
                              'application/vnd.ms-powerpoint',
                              'text/plain',
                              'image/*',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                              'application/vnd.ms-powerpoint',
                              'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
                              'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                              'application/vnd.ms-excel',
                            ]"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </card>

          <card v-if="paso == 4">
            <div class="d-flex flex-reverse" style="width: 100%">
              <button :disabled="camposInactivos" class="btn btn-outline-success m-3 mb-0" type="submit">Guardar Evaluación</button>
            </div>
            <div class="text-left p-4">
              <div>
                <span class="text-secondary"
                  ><b> Fases </b><span><b></b></span
                ></span>
              </div>
              <template v-if="items[3].Areas">
                <div class="mt-3 mb-3" v-for="Item in items[3].Areas" :key="Item.Id">
                  <p class="text-light">
                    <b>{{ Item.DescripcionPaso }}</b>
                  </p>
                  <div class="card border border-light p-3">
                    <span class="">{{ Item.ContextoPaso }}</span>
                    <div class="mt-3">
                      <b-form-select
                        class="col-4"
                        :disabled="camposInactivos"
                        v-model="Item.value"
                        value-field="id"
                        text-field="text"
                        :options="options"
                        :key="Item.Id"
                        :id="'select-' + Item.id"
                      >
                        <template #first>
                          <b-form-select-option selected :value="none" disabled>-- selecciona una opción --</b-form-select-option>
                        </template>
                      </b-form-select>
                      <div class="mt-3">
                        <span class="text-light">Cargar plan de mejoramiento (Opcional)</span>
                      </div>
                      <div class="mt-3">
                        <div v-if="!camposInactivos">
                          <DropFile
                            :urlDir="`users/pesv/evaluaciones/${usuario.empresa.id}/${sucursalSeleccionada}/${item.id}/${Item.FaseId}/${Item.Id}`"
                            :pathGet="`PesvPasosEvaluacion/GetPesvListaArchivosId/${item.id}/${Item.Id}/${Item.FaseId}`"
                            pathPost="PesvPasosEvaluacion/CreatePesvPasoEvaluacionArchivo"
                            :injectData="{
                              PesvEvaluacionId: item.id,
                              PasoId: Item.Id,
                              FaseId: Item.FaseId,
                              FechaArchivo: $moment.tz(new Date(), 'America/Costa_Rica').format('YYYY-MM-DDTHH:mm:ssZ'),
                            }"
                            :fileTypes="[
                              'application/pdf',
                              'application/docx',
                              'image/jpeg',
                              'image/png',
                              'image/gif',
                              'application/msword',
                              'application/vnd.ms-excel',
                              'application/vnd.ms-powerpoint',
                              'text/plain',
                              'image/*',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                              'application/vnd.ms-powerpoint',
                              'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
                              'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                              'application/vnd.ms-excel',
                            ]"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </card>

          <!-- <card v-if="paso == 2">
            <div class="d-flex flex-reverse" style="width: 100%">
              <button :disabled="camposInactivos" class="btn btn-outline-success m-3 mb-0" type="submit">Guardar Evaluación</button>
            </div>
            <div class="text-left p-4">
              <div>
                <span class="text-secondary"
                  ><b> Fases </b><span><b></b></span
                ></span>
              </div>
              <template v-if="items[1].Areas">
                <div class="mt-3 mb-3" v-for="(item, i) in items[1].Areas" :key="item.Id">
                  <p class="text-light">
                    <b>{{ item.DescripcionPaso }}</b>
                  </p>
                  <div class="card border border-light p-3">
                    <span class="">{{ item.ContextoPaso }}</span>
                    <div class="mt-3">
                      <b-form-select
                        class="col-4"
                        :disabled="camposInactivos"
                        v-model="item.value"
                        value-field="id"
                        text-field="text"
                        :options="options"
                        :key="item.Id"
                        :id="'select-' + item.id"
                      >
                        <template #first>
                          <b-form-select-option selected :value="none" disabled>-- selecciona una opción --</b-form-select-option>
                        </template>
                      </b-form-select>
                      <div class="mt-3">
                        <span class="text-light">Cargar plan de mejoramiento (Opcional)</span>
                      </div>
                      <div class="mt-3">
                        <div v-if="!camposInactivos" class="bg-dark pb-1" @dragover="dragover" @dragleave="dragleave" @drop="drop($event, i)" style="min-height: 20px">
                          <div class="text-center"><img class="img-fluid" style="width: 120px" src="~@/assets/images/nube.png" alt="" /> <br /></div>
                          <div class="flex w-full h-screen items-center justify-center text-center" id="app">
                            <div class="p-1">
                              <input
                                hidden
                                type="file"
                                multiple
                                name="fields[assetsFieldHandle][]"
                                id="assetsFieldHandle"
                                class="w-px h-px opacity-0 overflow-hidden absolute"
                                @change="onChange"
                                :ref="'file_' + i"
                                accept=".pdf,.jpg,.jpeg,.png"
                              />
                              <label for="assetsFieldHandle" class="block m-2"> <div>Arrastrar y soltar archivos de evidencia</div> </label><br />
                              <input v-if="actualfile == i" @click="onFileSelected2(item)" type="button" value="Subir archivos" />
                              <ul v-if="actualfile == i" class="mt-4" v-cloak>
                                <li class="text-left p-1" v-for="file in filelist" :key="file.name">
                                  {{ file.name
                                  }}<button class="ml-2 btn-secondary" type="button" @click="remove(i, filelist.dataFiles.indexOf(file))" title="Remove file">Eliminar</button>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </card>

          <card v-if="paso == 3">
            <div class="d-flex flex-reverse" style="width: 100%">
              <button :disabled="camposInactivos" class="btn btn-outline-success m-3 mb-0" type="submit">Guardar Evaluación</button>
            </div>
            <div class="text-left p-4">
              <div>
                <span class="text-secondary"
                  ><b> Fases </b><span><b></b></span
                ></span>
              </div>
              <template v-if="items[2].Areas">
                <div class="mt-3 mb-3" v-for="(item, i) in items[2].Areas" :key="item.Id">
                  <p class="text-light">
                    <b>{{ item.DescripcionPaso }}</b>
                  </p>
                  <div class="card border border-light p-3">
                    <span class="">{{ item.ContextoPaso }}</span>
                    <div class="mt-3">
                      <b-form-select
                        class="col-4"
                        :disabled="camposInactivos"
                        v-model="item.value"
                        value-field="id"
                        text-field="text"
                        :options="options"
                        :key="item.Id"
                        :id="'select-' + item.id"
                      >
                        <template #first>
                          <b-form-select-option selected :value="none" disabled>-- selecciona una opción --</b-form-select-option>
                        </template>
                      </b-form-select>
                      <div class="mt-3">
                        <span class="text-light">Cargar plan de mejoramiento (Opcional)</span>
                      </div>
                      <div class="mt-3">
                        <div v-if="!camposInactivos" class="bg-dark pb-1" @dragover="dragover" @dragleave="dragleave" @drop="drop($event, i)" style="min-height: 20px">
                          <div class="text-center"><img class="img-fluid" style="width: 120px" src="~@/assets/images/nube.png" alt="" /> <br /></div>
                          <div class="flex w-full h-screen items-center justify-center text-center" id="app">
                            <div class="p-1">
                              <input
                                hidden
                                type="file"
                                multiple
                                name="fields[assetsFieldHandle][]"
                                id="assetsFieldHandle"
                                class="w-px h-px opacity-0 overflow-hidden absolute"
                                @change="onChange"
                                :ref="'file_' + i"
                                accept=".pdf,.jpg,.jpeg,.png"
                              />
                              <label for="assetsFieldHandle" class="block m-2"> <div>Arrastrar y soltar archivos de evidencia</div> </label><br />
                              <input v-if="actualfile == i" @click="onFileSelected2(item)" type="button" value="Subir archivos" />
                              <ul v-if="actualfile == i" class="mt-4" v-cloak>
                                <li class="text-left p-1" v-for="file in filelist" :key="file.name">
                                  {{ file.name
                                  }}<button class="ml-2 btn-secondary" type="button" @click="remove(i, filelist.dataFiles.indexOf(file))" title="Remove file">Eliminar</button>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </card>

          <card v-if="paso == 4">
            <div class="d-flex flex-reverse" style="width: 100%">
              <button :disabled="camposInactivos" class="btn btn-outline-success m-3 mb-0" type="submit">Guardar Evaluación</button>
            </div>
            <div class="text-left p-4">
              <div>
                <span class="text-secondary"
                  ><b> Fases </b><span><b></b></span
                ></span>
              </div>
              <template v-if="items[3].Areas">
                <div class="mt-3 mb-3" v-for="(item, i) in items[3].Areas" :key="item.Id">
                  <p class="text-light">
                    <b>{{ item.DescripcionPaso }}</b>
                  </p>
                  <div class="card border border-light p-3">
                    <span class="">{{ item.ContextoPaso }}</span>
                    <div class="mt-3">
                      <b-form-select
                        class="col-4"
                        :disabled="camposInactivos"
                        v-model="item.value"
                        value-field="id"
                        text-field="text"
                        :options="options"
                        :key="item.Id"
                        :id="'select-' + item.id"
                      >
                        <template #first>
                          <b-form-select-option selected :value="none" disabled>-- selecciona una opción --</b-form-select-option>
                        </template>
                      </b-form-select>
                      <div class="mt-3">
                        <span class="text-light">Cargar plan de mejoramiento (Opcional)</span>
                      </div>
                      <div class="mt-3">
                        <div v-if="!camposInactivos" class="bg-dark pb-1" @dragover="dragover" @dragleave="dragleave" @drop="drop($event, i)" style="min-height: 20px">
                          <div class="text-center"><img class="img-fluid" style="width: 120px" src="~@/assets/images/nube.png" alt="" /> <br /></div>
                          <div class="flex w-full h-screen items-center justify-center text-center" id="app">
                            <div class="p-1">
                              <input
                                hidden
                                type="file"
                                multiple
                                name="fields[assetsFieldHandle][]"
                                id="assetsFieldHandle"
                                class="w-px h-px opacity-0 overflow-hidden absolute"
                                @change="onChange"
                                ref="file1"
                                accept=".pdf,.jpg,.jpeg,.png"
                              />
                              <label for="assetsFieldHandle" class="block m-2"> <div>Arrastrar y soltar archivos de evidencia</div> </label><br />
                              <input v-if="actualfile == i" @click="onFileSelected2(item)" type="button" value="Subir archivos" />
                              <ul v-if="actualfile == i" class="mt-4" v-cloak>
                                <li class="text-left p-1" v-for="file in filelist" :key="file.name">
                                  {{ file.name
                                  }}<button class="ml-2 btn-secondary" type="button" @click="remove(i, filelist.dataFiles.indexOf(file))" title="Remove file">Eliminar</button>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </card> -->
        </form>

        <card v-if="paso == 5">
          <div class="text-center p-4">
            <!-- <iframe title="Report Section" class="w-100 " height="450" src="https://app.powerbi.com/view?r=eyJrIjoiZjRhZDlkMGUtMDU5Yi00ODVhLTlmNDMtOWQ4NDFjMDg4YWU4IiwidCI6IjU3ZTM1Nzc2LWMzZDMtNGQxMS1iNGJkLTMzYTZlMzk5MTNlMSJ9" frameborder="0" allowFullScreen="true"></iframe> -->
            <h3>LISTA DE ARCHIVOS</h3>

            <div>
              <b-tabs content-class="mt-3">
                <b-tab :title="'Fase ' + n" v-for="n in 4" :key="n">
                  <table class="table table-borderless text-left">
                    <thead>
                      <tr>
                        <th scope="col">Nombre del archivo</th>
                        <th scope="col">Paso</th>
                        <th scope="col">Fecha</th>
                        <!-- <th scope="col">Acciones</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="it of listaArchivos">
                        <tr class="border-bottom" :key="it.id" v-if="it.faseId == n">
                          <td class="">
                            <span @click="gotoFile(it)" class="pointer">
                              {{ it.nombreArchivo }}
                            </span>
                          </td>
                          <td class="">
                            <span class=""> {{ it.pasoId }} </span>
                          </td>
                          <td class="">
                            <span class="">
                              {{ $moment.tz(it.fechaArchivo, "America/Costa_Rica").format("YYYY-MM-DD HH:mm") }}
                            </span>
                          </td>
                          <td class="h4 text-center">
                            <span class="px-1">
                              <font-awesome-icon @click="gotoFile(it)" class="text-outline-success text-warning" icon="eye" />
                              <!-- <font-awesome-icon @click="gotoFile(it)" class="text-outline-success text-warning" icon="eye" /> -->
                            </span>
                            <!-- <span class="px-1">
                              <font-awesome-icon class="text-outline-success text-success" icon="download" />
                            </span>
                            <span class="px-1">
                              <font-awesome-icon @click="removeFile(it)" class="text-outline-success text-danger" icon="trash" />
                            </span> -->
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </card>
        <card v-if="paso == 6">
          <div class="text-center p-4">
            <!-- <iframe title="Report Section" class="w-100 " height="450" src="https://app.powerbi.com/view?r=eyJrIjoiZjRhZDlkMGUtMDU5Yi00ODVhLTlmNDMtOWQ4NDFjMDg4YWU4IiwidCI6IjU3ZTM1Nzc2LWMzZDMtNGQxMS1iNGJkLTMzYTZlMzk5MTNlMSJ9" frameborder="0" allowFullScreen="true"></iframe> -->
            <!-- src="https://app.powerbi.com/view?r=eyJrIjoiOTM4NzE2ZTMtNzU1YS00ZjM2LTg3Y2EtZWM2YzRkNDg4NTU3IiwidCI6IjU3ZTM1Nzc2LWMzZDMtNGQxMS1iNGJkLTMzYTZlMzk5MTNlMSJ9" -->

            <PowerBiIframe class="container-iframe" title="Reporte PESV" :user="userLoggedIn" :reportData="aboutSeccionResultados"></PowerBiIframe>
          </div>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from "vuex";
import PowerBiIframe from "@/components/helexium/PowerBiIframe.vue";
import DropFile from "@/components/helexium/DropFileV2.vue";

// import { core } from "../../../config/pluginInit";
const Swal = require("sweetalert2");

export default {
  components: {
    PowerBiIframe,
    DropFile,
  },
  name: "pesv",
  data() {
    return {
      paso: "1",
      texto: [
        {
          id: 1,
          estandar: "RECURSOS (10%)",
          estandar_texto:
            "Recursos financieros, técnicos,  humanos y de otra índole requeridos para coordinar y desarrollar el Sistema de Gestión de la Seguridad y Salud en el Trabajo (SG-SST) (4%) ",
          item_estandar: "1.1.1 Responsable del sistema de Gestión de Seguridad y Salud en el trabajo SG-SST",
          popover: "prueba",
          seleccionar: "prueba",
          seleccionar_archivo: "prueba",
          // titulo:"",
        },
        {
          id: 2,
          estandar: "RECURSOS (10%)",
          estandar_texto:
            "Recursos financieros, técnicos,  humanos y de otra índole requeridos para coordinar y desarrollar el Sistema de Gestión de la Seguridad y Salud en el Trabajo (SG-SST) (4%) ",
          item_estandar: "1.1.1 Responsable del sistema de Gestión de Seguridad y Salud en el trabajo SG-SST",
          popover: "prueba",
          seleccionar: "prueba",
          seleccionar_archivo: "prueba",
          // titulo:"",
        },
      ],
      items: [{ Areas: [] }, { Areas: [] }, { Areas: [] }, { Areas: [] }],
      file2: null,
      selected: null,
      options: [
        { id: 1, text: "Cumple" },
        { id: 2, text: "No cumple" },
        { id: 3, text: "No aplica" },
      ],
      usuario: {},
      item: {
        EmpresaId: 0,
        SucursalId: "00000000-0000-0000-0000-000000000000",
        FechaIngreso: this.$moment.tz(new Date(), "America/Costa_Rica").format("YYYY-MM-DDTHH:mm:ssZ"),
        FechaEvaluacion: this.$moment.tz(new Date(), "America/Costa_Rica").format("YYYY-MM-DDTHH:mm:ssZ"),
        Estado: "",
      },
      listaSucursales: [],
      sucursalSeleccionada: "",
      camposInactivos: true,
      botonNuevaEvaluacion: true,
      file1: null,
      filename1: null,
      files: [],
      filelist: [],
      actualfile: -1,
      listaArchivos: [],
      OpenClose: false,
      aboutSeccionResultados: {},
    };
  },
  created() {
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
    if (this.usuario.rol.nivel == 6) {
      this.$router.push("/helex/inspeccionVehiculo");
    }
  },
  async mounted() {
    this.$isLoading(true);
    console.log("ussssssssssss", this.usuario);
    this.item.EmpresaId = this.usuario.empresa.id;
    //this.item.SucursalId= this.usuario.empresa
    //this.item.FechaEvaluacion= new Date()
    await this.getSucursales();
    // core.index();
    // window.$("#datatable").DataTable();
    this.items = await this.getData();
    this.getAboutSeccionResultados();
    this.$isLoading(false);
  },
  computed: {
    ...mapGetters(["userLoggedIn"]),
  },
  methods: {
    getAboutSeccionResultados() {
      try {
        const empresaId = this.userLoggedIn.empresa.id;
        this.$store.getters
          .fetchGet({ path: `IFrame/empresa/${empresaId}/seccion/PESV/last` })
          .then((repsonse) => {
            if (repsonse.ok) {
              return repsonse.json();
            }
          })
          .then((result) => {
            this.aboutSeccionResultados = result;
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log("error", error);
      }
    },
    gotoFile(it) {
      console.log(it);
      window.open(it.urlArchivo, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500");
    },
    showToast(type, message) {
      console.log(type);
      if (type == "success") {
        this.$toast.success(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      }
      if (type == "error")
        this.$toast.error(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
    },
    onChange(i) {
      this.actualfile = i;
      this.filelist = [...this.$refs["file_" + i].files];
      console.log("onchange this.filelist", this.filelist);
    },
    remove(i, index) {
      this.filelist.dataFiles.splice(index, 1);
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event, i) {
      console.log("i", i);
      console.log("refs --->", this.$refs);
      event.preventDefault();
      //console.log(event.dataTransfer.files.length);
      this.files = event;

      // this.$refs.file.files = event.dataTransfer.files;
      this.$refs["file_" + i].files = event.dataTransfer.files;
      this.onChange(i); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },
    async renameFile(nameFile) {
      this.realName = nameFile;
      let collectionBad = "á é í ó ú Á É Í Ó Ú ñ Ñ";
      let collectionGood = "a e i o u A E I O U n N";
      let collectionBadA = collectionBad.split(" ");
      let collectionGoodA = collectionGood.split(" ");
      let count = 0;
      for await (let it of collectionBadA) {
        let pos = nameFile.indexOf(it);
        if (pos > 0) {
          nameFile = nameFile.replaceAll(it, collectionGoodA[count]);
        }
        pos = 0;
        count++;
      }
      return nameFile;
    },
    clearVarFiles() {
      this.file1 = null;
      this.finename1 = null;
      this.files = [];
      this.filelist = [];
    },
    async onFileSelected2(item) {
      try {
        this.$isLoading(true);
        //let path = "/"+"pesv"+"/"+this.usuario.empresa.id+"/"+this.sucursalSeleccionada+"/"+this.item.id+"/"+item.FaseId+"/"+item.Id+"/"
        //empresa,sucursal,pesvevaluacionid,fase,paso
        let data = {
          empresa: this.usuario.empresa.id,
          sucursal: this.sucursalSeleccionada,
          pesvevaluacionid: this.item.id,
          fase: item.FaseId,
          paso: item.Id,
        };
        console.log(item);
        console.log(data);
        this.files = this.filelist;
        for await (let it of this.filelist) {
          //let loader = this.$loading.show();
          try {
            this.file1 = it; //event.target.files[0];
            this.filename1 = await this.renameFile(this.file1.name); // Math.floor(Math.random() * 9999999999999 + 1);
            if (this.filename1 != null) {
              let url = ".|site1|users|pesv|evaluaciones|" + this.usuario.empresa.id + "|" + this.sucursalSeleccionada + "|" + this.item.id + "|" + item.FaseId + "|" + item.Id;
              let uploadImg = await this.$store.dispatch("onFileCustom", {
                filename: this.filename1,
                file: this.file1,
                url: url,
              });
              if (uploadImg == true) {
                console.log("archivo subido...");
                let data = {
                  PesvEvaluacionId: this.item.id,
                  PasoId: item.Id,
                  FaseId: item.FaseId,
                  UrlArchivo:
                    "https://www.helexiumfiles.com/users/pesv/evaluaciones/" +
                    this.usuario.empresa.id +
                    "/" +
                    this.sucursalSeleccionada +
                    "/" +
                    this.item.id +
                    "/" +
                    item.FaseId +
                    "/" +
                    item.Id +
                    "/" +
                    this.filename1,
                  NombreArchivo: this.filename1,
                  FechaArchivo: this.$moment.tz(new Date(), "America/Costa_Rica").format("YYYY-MM-DDTHH:mm:ssZ"),
                };
                await this.$store.dispatch("hl_post", {
                  path: "PesvPasosEvaluacion/CreatePesvPasoEvaluacionArchivo",
                  data: data,
                });

                this.showToast("success", "Archivo subido correctamente!");

                //this.getData();
                this.clearVarFiles();
              }
            } else {
              //console.log("nel");
            }
            // loader.hide();
          } catch (error) {
            console.log("errror upload", error);
            //loader.hide();
          }
        }
        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);
        console.log("error");
      }
    },
    async crearEvaluacion() {
      this.item.Estado = "Incompleto";
      let res = await this.$store.dispatch("hl_post", {
        path: "PesvPasosEvaluacion/Create/",
        data: this.item,
      });
      console.log(res);
      this.item.id = res;
      this.camposInactivos = false;
      this.botonNuevaEvaluacion = true;
    },
    async obtenerEvaluacionSucursal() {
      this.$isLoading(true);
      try {
        //this.items=[]
        let res = await this.$store.dispatch("hl_get", {
          path: "PesvPasosEvaluacion/" + this.sucursalSeleccionada,
        });
        this.$isLoading(false);
        console.log("get evaluación sucursales... ", res);
        if (res.length > 0) {
          console.log("1");
          this.item = res[0];
          this.item.FechaEvaluacion = this.$moment.tz(this.item.fechaEvaluacion, "America/Costa_Rica").format("YYYY-MM-DD");
          //consultando pasos
          let resPasos = await this.$store.dispatch("hl_get", {
            path: "PesvPasosEvaluacion/GetPasosEvaluacion/" + this.item.id,
          });
          console.log(" pasos *****************************", resPasos);
          //recorrer areas en this.items asignando valor de acuerdo a respasos
          let items = await this.getData();
          for await (let itData of items[0].Areas) {
            for await (let itemPaso of resPasos) {
              if (itData.Id == itemPaso.pasoId) {
                console.log(itemPaso);
                itData.value = itemPaso.calificacionId;
                itData.PesvPasoId = itemPaso.id;
              }
            }
          }
          for await (let itData of items[1].Areas) {
            for await (let itemPaso of resPasos) {
              if (itData.Id == itemPaso.pasoId) {
                console.log(itemPaso);
                itData.value = itemPaso.calificacionId;
                itData.PesvPasoId = itemPaso.id;
              }
            }
          }
          for await (let itData of items[2].Areas) {
            for await (let itemPaso of resPasos) {
              if (itData.Id == itemPaso.pasoId) {
                console.log(itemPaso);
                itData.value = itemPaso.calificacionId;
                itData.PesvPasoId = itemPaso.id;
              }
            }
          }
          for await (let itData of items[3].Areas) {
            for await (let itemPaso of resPasos) {
              if (itData.Id == itemPaso.pasoId) {
                console.log(itemPaso);
                itData.value = itemPaso.calificacionId;
                itData.PesvPasoId = itemPaso.id;
              }
            }
          }
          this.items = items;
          console.log(" items ", this.items);
          Swal.fire("Atención!", "Encontramos una evaluación en proceso para esta sucursal.", "info");
          this.camposInactivos = false;
          this.botonNuevaEvaluacion = true;
        } else {
          this.items = await this.getData();
          console.log("2");
          this.item = {
            EmpresaId: this.usuario.empresa.id,
            SucursalId: this.sucursalSeleccionada,
            FechaIngreso: this.$moment.tz(new Date(), "America/Costa_Rica").format("YYYY-MM-DD"),
            FechaEvaluacion: this.$moment.tz(new Date(), "America/Costa_Rica").format("YYYY-MM-DD"),
            Estado: "",
          };
          this.$isLoading(false);
          Swal.fire("Atención!", "No hay evaluaciones en proceso para esta sucursal.", "info");
          this.camposInactivos = true;
          this.listaArchivos = [];
          this.botonNuevaEvaluacion = false;
        }
      } catch (error) {
        this.item = {
          EmpresaId: this.usuario.empresa.id,
          SucursalId: this.sucursalSeleccionada,
          FechaIngreso: this.$moment.tz(new Date(), "America/Costa_Rica").format("YYYY-MM-DD"),
          FechaEvaluacion: this.$moment.tz(new Date(), "America/Costa_Rica").format("YYYY-MM-DD"),
          Estado: "",
        };
        this.$isLoading(false);
        console.log("err", error);
        this.camposInactivos = true;
        this.botonNuevaEvaluacion = false;
      }
    },
    async getSucursales() {
      console.log("usuario------>", this.usuario);
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Sucursal/ListSucursalEmpresa/" + this.usuario.empresa.id,
        });
        console.log("get sucursales... ", res);
        if (res.length > 0) {
          this.listaSucursales = res;
        } else {
          this.listaSucursales = [];
        }
      } catch (error) {
        this.listaSucursales = [];
        console.log("err", error);
      }
    },
    async generarPasosEvaluacion(PesvEvaluacionId) {
      let data = [];
      this.item.Estado = "Completado";
      for await (let it of this.items[0].Areas) {
        console.log("pasoid / valor", it.Id, " ", it.value);
        if (it.value != undefined) {
          let itemData = {
            Id: it.PesvPasoId,
            PesvEvaluacionId: PesvEvaluacionId,
            PasoId: it.Id,
            CalificacionId: it.value,
            UrlArchivo: "",
          };
          data.push(itemData);
        } else {
          this.item.Estado = "Incompleto";
        }
      }
      for await (let it of this.items[1].Areas) {
        console.log("pasoid / valor", it.Id, " ", it.value);
        if (it.value != undefined) {
          let itemData = {
            Id: it.PesvPasoId,
            PesvEvaluacionId: PesvEvaluacionId,
            PasoId: it.Id,
            CalificacionId: it.value,
            UrlArchivo: "",
          };
          data.push(itemData);
        } else {
          this.item.Estado = "Incompleto";
        }
      }
      for await (let it of this.items[2].Areas) {
        console.log("pasoid / valor", it.Id, " ", it.value);
        if (it.value != undefined) {
          let itemData = {
            Id: it.PesvPasoId,
            PesvEvaluacionId: PesvEvaluacionId,
            PasoId: it.Id,
            CalificacionId: it.value,
            UrlArchivo: "",
          };
          data.push(itemData);
        } else {
          this.item.Estado = "Incompleto";
        }
      }
      for await (let it of this.items[3].Areas) {
        console.log("pasoid / valor", it.Id, " ", it.value);
        if (it.value != undefined) {
          let itemData = {
            Id: it.PesvPasoId,
            PesvEvaluacionId: PesvEvaluacionId,
            PasoId: it.Id,
            CalificacionId: it.value,
            UrlArchivo: "",
          };
          data.push(itemData);
        } else {
          this.item.Estado = "Incompleto";
        }
      }
      return data;
    },
    async saveData() {
      console.log(this.items);
      try {
        if (this.sucursalSeleccionada == "") {
          alert("falta sucursal");
          return;
        }
        this.$isLoading(true);
        this.item.SucursalId = this.sucursalSeleccionada;
        this.item.FechaEvaluacion = this.$moment.tz(this.item.FechaEvaluacion, "America/Costa_Rica").format("YYYY-MM-DDTHH:mm:ssZ");
        if (this.item.id) {
          // alert('es una actualización')
          let data = await this.generarPasosEvaluacion(this.item.id);

          console.log("items ----> ", data);
          await this.$store.dispatch("hl_post", {
            path: "PesvPasosEvaluacion/CreatePasos/",
            data: data,
          });

          if (this.item.Estado == "Completado") {
            await this.$store.dispatch("hl_post", {
              path: "PesvPasosEvaluacion/Update/",
              data: this.item,
            });
            this.items = [];
          }
          this.$isLoading(false);

          Swal.fire("Listo!", "Registro almacenado correctamente, Estado de la evaluación:" + this.item.Estado, "success");
        } else {
          //alert('es una nueva')
          // let data = await this.generarPasosEvaluacion(res)
          // console.log('items ----> ',data)
          // await this.$store.dispatch("hl_post", {
          //   path: "PesvPasosEvaluacion/CreatePasos/", data: data
          // });
          // Swal.fire("Listo!", "Registro almacenado correctamente, Estado de la evaluación:"+this.item.Estado, "success");
          // console.log("post empresas...", res);
          // if(res)
          // console.log('ok')
          //  else
          //   alert('Verificar')
        }
      } catch (error) {
        this.item = {};
        this.$isLoading(false);
        Swal.fire("Error!", "Intentalo nuevamente.", "Error");

        console.log("err", error);
      }
    },
    async getData() {
      this.$isLoading(true);
      try {
        let res = await this.$store.dispatch("getw", { path: "pesv/" });
        this.$isLoading(false);
        if (res.length > 0) {
          console.log(this.items);
          await this.getListaArchivos();
          return res;
        } else {
          return [];
        }
      } catch (error) {
        this.$isLoading(false);
        return [];
      }
    },
    async getListaArchivos() {
      if (this.item.id == undefined || this.item.id == null) {
        this.listaArchivos = [];
        return;
      }
      this.$isLoading(true);
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "PesvPasosEvaluacion/GetPesvListaArchivos/" + this.item.id,
        });
        console.log("res", res);
        this.$isLoading(false);
        if (res.length > 0) {
          this.listaArchivos = res;
        } else {
          this.listaArchivos = [];
        }
        console.log(this.listaArchivos);
        //return res
      } catch (error) {
        this.$isLoading(false);
      }
    },
  },
};
</script>
<style scoped>
.text-white {
  color: white !important;
}

.container-iframe {
  width: 100%;
  min-height: 70vh;
  position: relative;
}

.btn-controle-full-size {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: transparent;
  cursor: pointer;
}
</style>
